import React, { Component } from 'react';

import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Switch,
} from 'react-router-dom';

import './App.css';

import Logged from './pages/Logged';
import Login from './pages/Login';

class App extends Component {
  render() {
    return (
      <Router>
        <div>
          <Switch>
            <Route
              path="/u/dashboard-operacional"
              render={props => <Logged operationalDashboard {...props} />}
            />
            <Route path="/u" component={Logged} />
            <Route exact path="/" component={Login} />
            <Redirect to="/" />
          </Switch>
        </div>
      </Router>
    );
  }
}

export default App;
